import React, { useState, useEffect } from 'react';
import cn from 'clsx';
import { Form, Modal } from 'antd';
import { AModal, AButton, ARadioGroup, ARadio, ATextarea } from 'components/Antd';
import ADatePicker from 'components/Antd/DatePicker';
import FormItem from 'views/DesktopReview/components/FormItem';
import { getMomentDate } from 'util/date';
import T from 'i18n-react';
import classes from './SetDatesModal.module.scss';

const SetDatesModal = ({
  open,
  onClose,
  onSubmit,
  defaultSelectedDocument,
  editableFile,
  submitLoading,
}) => {
  const hasEditableFile = !!editableFile?.name;
  const [modal, contextHolder] = Modal.useModal();
  const [isExportType, setIsExportType] = useState('');
  const [form] = Form.useForm();
  const handleConfirm = ({ title, description, submitText }, cb) => {
    modal.confirm({
      title,
      icon: <></>,
      content: description,
      onOk() {
        if (cb) cb();
      },
      okText: submitText,
      closable: true,
      onCancel() {},
      centered: true,
      cancelButtonProps: {
        className: classes.cancelBtn,
      },
      className: classes.warningModal,
    });
  };

  useEffect(() => {
    if (open) {
      setIsExportType('');
    }
  }, [open]);

  return (
    <>
      <AModal
        title="Set Dates & Reminder"
        open={open}
        onCancel={onClose}
        closable
        width={700}
        className={cn(classes.modalWrapper)}>
        <Form
          name="setDatesForm"
          initialValues={{
            issueDate: getMomentDate(defaultSelectedDocument?.issueDate) || '',
            expiryDate: getMomentDate(defaultSelectedDocument?.expiryDate) || '',
            reviewDate: getMomentDate(defaultSelectedDocument?.reviewDate) || '',
            emailReminder: defaultSelectedDocument?.reminderType || '',
            customDate: getMomentDate(defaultSelectedDocument?.reminderDate) || '',
            note: defaultSelectedDocument?.note || '',
          }}
          onFinish={(values) => {}}
          form={form}
          autoComplete="off"
          layout="vertical"
          className={classes.formWrapper}>
          <FormItem
            label="Issue Date"
            name="issueDate"
            // rules={[{ required: true, message: 'This field is required!' }]}
          >
            <ADatePicker name="issueDate" size="large" radius="md" />
          </FormItem>
          <FormItem
            label="Expiry Date"
            // rules={[{ required: true, message: 'This field is required!' }]}
            name="expiryDate"
            normalize={(value, preValue) => {
              return preValue;
            }}>
            <ADatePicker
              name="expiryDate"
              size="large"
              radius="md"
              onChange={(val) => {
                setTimeout(() => {
                  if (form.getFieldValue('emailReminder') === 'expiryDate') {
                    handleConfirm(
                      {
                        title: 'Are you sure to reset?',
                        description: 'Reminder note will be cleared.',
                        submitText: 'Reset',
                      },
                      () => {
                        form.setFieldValue('emailReminder', '');
                        form.setFieldValue('expiryDate', val);
                        setTimeout(() => {
                          form.validateFields(['emailReminder']);
                          form.validateFields(['expiryDate']);
                        }, 0);
                        if (val) {
                          form.setFieldValue('reviewDate', val.clone().subtract(7, 'days'));
                          setTimeout(() => {
                            form.validateFields(['reviewDate']);
                          }, 0);
                        }
                      }
                    );
                  } else {
                    form.setFieldValue('expiryDate', val);
                    setTimeout(() => {
                      form.validateFields(['expiryDate']);
                    }, 0);
                    if (val) {
                      form.setFieldValue('reviewDate', val.clone().subtract(7, 'days'));
                      setTimeout(() => {
                        form.validateFields(['reviewDate']);
                      }, 0);
                    }
                  }
                }, 0);
              }}
            />
          </FormItem>
          <FormItem
            label="Review Date"
            // rules={[{ required: true, message: 'This field is required!' }]}
            name="reviewDate"
            normalize={(value, preValue) => {
              return preValue;
            }}>
            <ADatePicker
              name="reviewDate"
              size="large"
              radius="md"
              onChange={(val) => {
                setTimeout(() => {
                  if (form.getFieldValue('emailReminder') === 'reviewDate') {
                    handleConfirm(
                      {
                        title: 'Are you sure to reset?',
                        description: 'Reminder note will be cleared.',
                        submitText: 'Reset',
                      },
                      () => {
                        form.setFieldValue('emailReminder', '');
                        form.setFieldValue('reviewDate', val);
                        setTimeout(() => {
                          form.validateFields(['emailReminder']);
                          form.validateFields(['reviewDate']);
                        }, 0);
                      }
                    );
                  } else {
                    form.setFieldValue('reviewDate', val);
                    setTimeout(() => {
                      form.validateFields(['reviewDate']);
                    }, 0);
                  }
                }, 0);
              }}
            />
          </FormItem>
          <div className={classes.emailReminderWrapper}>
            <span
              className={classes.clearReminder}
              onClick={() => {
                form.setFieldValue('emailReminder', '');
                form.setFieldValue('customDate', '');
                form.setFieldValue('note', '');
              }}>
              Clear Reminder Option
            </span>
            <FormItem shouldUpdate noMargin>
              {() => {
                const values = form.getFieldsValue();
                return (
                  <>
                    <FormItem
                      label="Email Reminder"
                      name="emailReminder"
                      // rules={[{ required: true, message: 'This field is required!' }]}
                    >
                      <ARadioGroup>
                        <ARadio value="onExpiryDate" disabled={!values.expiryDate}>
                          On Expiry Date
                        </ARadio>
                        <ARadio value="onReviewDate" disabled={!values.reviewDate}>
                          On Review Date
                        </ARadio>
                        <ARadio value="onCustomDate">Custom</ARadio>
                      </ARadioGroup>
                    </FormItem>
                    {!!values.emailReminder && (
                      <div className={classes.reminderNoteWrapper}>
                        {values.emailReminder === 'onCustomDate' && (
                          <FormItem
                            label=""
                            name="customDate"
                            // rules={[
                            //   (formInstance) => {
                            //     const emailReminder = formInstance.getFieldValue('emailReminder');
                            //     return {
                            //       validator(_, value) {
                            //         if (emailReminder === 'onCustomDate' && !value)
                            //           return Promise.reject(
                            //             new Error(T.translate('error.fieldRequired'))
                            //           );
                            //         return Promise.resolve();
                            //       },
                            //     };
                            //   },
                            // ]}
                          >
                            <ADatePicker name="customDate" size="large" radius="md" />
                          </FormItem>
                        )}
                        <FormItem label="Note" name="note">
                          <ATextarea name="note" placeholder="Fill" />
                        </FormItem>
                        <span className={classes.notWarning}>
                          Note will be sent together with reminder email.
                        </span>
                      </div>
                    )}
                  </>
                );
              }}
            </FormItem>
          </div>
          <div className={classes.clearSettingWrapper}>
            <AButton
              type="danger"
              ghost
              onClick={() => {
                handleConfirm(
                  {
                    title: 'Clear All Settings?',
                    description: 'All settings in the popup will be cleared.',
                    submitText: 'Clear',
                  },
                  () => {
                    form.setFieldValue('issueDate', '');
                    form.setFieldValue('expiryDate', '');
                    form.setFieldValue('reviewDate', '');
                    form.setFieldValue('emailReminder', '');
                    form.setFieldValue('customDate', '');
                    form.setFieldValue('note', '');
                  }
                );
              }}
              htmlType="button"
              size="large">
              Clear All Settings
            </AButton>
          </div>
          <div
            className={cn(classes.footer, {
              [classes.exportFooter]: hasEditableFile,
            })}>
            {hasEditableFile ? (
              <>
                <AButton
                  htmlType="button"
                  type="primary"
                  size="large"
                  className={classes.confirmBtn}
                  onClick={() => {
                    setIsExportType('pdf');
                    const values = form.getFieldsValue();
                    if (onSubmit) onSubmit(values, 'pdf');
                  }}
                  disabled={submitLoading && isExportType !== 'pdf'}
                  loading={isExportType === 'pdf' ? submitLoading : false}>
                  Confirm & Download PDF
                </AButton>
                <AButton
                  htmlType="button"
                  type="primary"
                  size="large"
                  className={classes.confirmBtn}
                  onClick={() => {
                    setIsExportType('docx');
                    const values = form.getFieldsValue();
                    if (onSubmit) onSubmit(values, 'docx');
                  }}
                  disabled={submitLoading && isExportType !== 'docx'}
                  loading={isExportType === 'docx' ? submitLoading : false}>
                  Confirm & Download Word Doc
                </AButton>
              </>
            ) : (
              <AButton
                htmlType="button"
                type="primary"
                size="large"
                className={classes.confirmBtn}
                onClick={() => {
                  const values = form.getFieldsValue();
                  if (onSubmit) onSubmit(values);
                }}
                loading={submitLoading}>
                Confirm
              </AButton>
            )}
          </div>
        </Form>
      </AModal>
      {contextHolder}
    </>
  );
};

export default SetDatesModal;
